import { ref } from 'vue'

const defaults = {
    name: 'globalUploader',
    click: false, 
    highlightTimeout: 500, 
}

const globalUploader = ref({
    ...defaults,
    enabled: false,
    uploaderId: null,
    onUploadStart: null,
    onUploadStop: null,
    onFileUploadDone: null,
    onAllFilesUploadDone: null,
})

const updateGlobalUploader = (config) => {
    globalUploader.value = { ...defaults, ...config }
}

export {
    updateGlobalUploader,
}

export default globalUploader
